import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Formsy from "formsy-react";
import { Button, CardActions } from "react-md";
import { Link } from "react-router-dom";

import MyInput from "../../../Components/MyInput/MyInput";

const BasicCoogForm = ({ form, password, login, inError, errorText, handleSubmitCallback }) => {
    const [canSubmit, setCanSubmit] = useState(false);

    useEffect(() => {
        setCanSubmit(!!login && !!password); // Update button state based on inputs
    }, [login, password]);

    const handleSubmit = (data) => {
        console.log("Form submitted:", data);
        handleSubmitCallback(data);
    };

    return (
        <Formsy
            key="basic-coog-block"
            onValidSubmit={handleSubmit}
            onValid={() => setCanSubmit(true)}
            onInvalid={() => setCanSubmit(false)}
            autoComplete="off"
        >
            <MyInput
                id="login"
                name="login"
                label={form.loginLabel}
                placeholder={form.loginPlaceholder}
                validationError={form.loginValidationError}
                required
                text="text"
                error={inError}
                errorText={errorText}
                value={login}
                autoComplete="nope"
            />
            <MyInput
                id="password"
                name="password"
                label={form.passwordLabel}
                placeholder={form.passwordPlaceholder}
                validationError="Field empty"
                required
                type="password"
                error={inError}
                errorText={errorText}
                value={password}
                autoComplete="new-password"
            />
            <div id="forgetPassword" className="forgot-password">
                <Link to="/password">Mot de passe oublié ?</Link>
            </div>
            <CardActions className="md-cell md-cell--12">
                <Button
                    raised
                    disabled={!canSubmit}
                    primary={canSubmit}
                    type="submit"
                    className="coog-login-button"
                >
                    {form.submitLabel}
                </Button>
            </CardActions>
        </Formsy>
    );
};

BasicCoogForm.propTypes = {
    form: PropTypes.shape({
        loginLabel: PropTypes.string.isRequired,
        loginPlaceholder: PropTypes.string.isRequired,
        loginValidationError: PropTypes.string.isRequired,
        passwordLabel: PropTypes.string.isRequired,
        passwordPlaceholder: PropTypes.string.isRequired,
        submitLabel: PropTypes.string.isRequired,
    }).isRequired,
    password: PropTypes.string,
    login: PropTypes.string,
    inError: PropTypes.bool,
    errorText: PropTypes.string,
};

export default BasicCoogForm;
